import { render, staticRenderFns } from "./Initiative.vue?vue&type=template&id=0533b88c&scoped=true&"
import script from "./Initiative.vue?vue&type=script&lang=js&"
export * from "./Initiative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533b88c",
  null
  
)

export default component.exports